import React, { useEffect, ReactElement } from 'react';
import { Form, Row, Col, Input } from 'antd';
import { FormInstance } from 'antd/lib/form';

import { ClientCredentials } from '../../types/Client';

interface ClientCredentialsInputsProps {
    // eslint-disable-next-line react/no-unused-prop-types
    form: FormInstance;
    isDetailMode: boolean;
    data?: ClientCredentials;
}

const ClientCredentialsInputs: React.FC<ClientCredentialsInputsProps> = ({
    isDetailMode,
    data,
}: ClientCredentialsInputsProps): ReactElement => {
    const { apiSecret, v3email, v3password } = data || {};
    return (
        <>
            <Row gutter={24}>
                <Col lg={{ span: 18, offset: 3 }} md={{ span: 18, offset: 3 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                    <Form.Item label="API secret" name="apiSecret">
                        {isDetailMode ? <span>{apiSecret}</span> : <Input title="Client API secret" />}
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={24}>
                <Col lg={{ span: 8, offset: 3 }} md={{ span: 8, offset: 3 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                    <Form.Item label="API v3 email" name="v3email">
                        {isDetailMode ? <span>{v3email}</span> : <Input title="Client's API v3 email" />}
                    </Form.Item>
                </Col>
                <Col lg={{ span: 8, offset: 2 }} md={{ span: 8, offset: 2 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                    <Form.Item label="API v3 password" name="v3password">
                        {isDetailMode ? <span>{v3password}</span> : <Input title="Client's API v3 password" />}
                    </Form.Item>
                </Col>
            </Row>
        </>
    );
};

interface ClientCredentialsFormSectionProps {
    clientCredentials?: ClientCredentials;
    isDetailMode: boolean;
    form: FormInstance;
}

const ClientCredentialsFormSection: React.FC<ClientCredentialsFormSectionProps> = ({
    form,
    clientCredentials,
    isDetailMode,
}: ClientCredentialsFormSectionProps): React.ReactElement => {
    useEffect(() => {
        if (clientCredentials) {
            form.setFields([
                { name: 'apiSecret', value: clientCredentials.apiSecret },
                { name: 'v3email', value: clientCredentials.v3email },
                { name: 'v3password', value: clientCredentials.v3password },
            ]);
        }
    }, [clientCredentials]);

    return <ClientCredentialsInputs form={form} isDetailMode={isDetailMode} data={clientCredentials} />;
};

export default ClientCredentialsFormSection;
